import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { assignTypeToValue } from "../label-value-pair.helper";

@Component({
  selector: "kwikui-label-value-pair-value",
  templateUrl: "./label-value-pair-value.component.html",
  styleUrls: ["./label-value-pair-value.component.css"]
})
export class LabelValuePairValueComponent implements OnInit {
  @Input()
  config;

  @Input()
  value;

  type;

  constructor() {}

  ngOnInit(): void {
    this.type = assignTypeToValue(this.value);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty("label") && !changes.label.firstChange) {
      this.value = changes.value.currentValue;
      this.type = assignTypeToValue(this.value);
    }

    if (changes.hasOwnProperty("config") && !changes.config.firstChange) {
      this.config = changes.config.currentValue;
    }
  }
}
